import { render, staticRenderFns } from "./SwapProvidersList.vue?vue&type=template&id=4b9e0420&scoped=true"
import script from "./SwapProvidersList.vue?vue&type=script&lang=js"
export * from "./SwapProvidersList.vue?vue&type=script&lang=js"
import style0 from "./SwapProvidersList.vue?vue&type=style&index=0&id=4b9e0420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e0420",
  null
  
)

export default component.exports